import { UserContext } from '@web/contexts/User';
import { hasScopeFun } from '@web/utility';
import { useContext } from 'react';
export var useHasScope = function (required) {
    var currentUser = useContext(UserContext).currentUser;
    var scopes = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.scopes) || [];
    return hasScopeFun(required, scopes);
};
